import { injectable } from 'inversify';
import { INotificationMutationResolveService } from './notification-mutation-resolve.interface';

@injectable()
export class NotificationMutationResolveMock implements INotificationMutationResolveService {
    resolve: (id: string) => void;
}
